module.exports = __webpack_public_path__ + "static/media/page3-deer.76b7b6fe.png";